import { useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import { api, formatApiError } from "../lib/api";
import { Button } from "./ui/button";
import { PasswordInput } from "./ui/password-input";
import { Label } from "./ui/label";
import { ShieldCheck } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function ForcePasswordChange() {
  const { user, logout, refresh } = useAuth();
  const [pw, setPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [saving, setSaving] = useState(false);

  if (!user || !user.must_change_password) return null;

  const submit = async () => {
    if (pw.length < 6) { toast.error("Password must be at least 6 characters"); return; }
    if (pw !== confirm) { toast.error("Passwords do not match"); return; }
    setSaving(true);
    try {
      await api.post("/auth/set-initial-password", { new_password: pw });
      toast.success("Password updated — welcome aboard!");
      await refresh();
    } catch (e) { toast.error(formatApiError(e)); }
    finally { setSaving(false); }
  };

  return (
    <div className="fixed inset-0 z-[200] bg-background/95 backdrop-blur-sm flex items-center justify-center p-4" data-testid="force-password-change">
      <div className="w-full max-w-md border border-border bg-card p-8">
        <div className="flex items-center gap-2 mb-1"><ShieldCheck size={20} className="text-primary" /><div className="label-mono">Secure your account</div></div>
        <h1 className="font-heading text-2xl mb-2">Set a new password</h1>
        <p className="text-sm text-muted-foreground mb-6">You're signed in with a temporary password. Please choose your own password to continue.</p>
        <div className="space-y-4">
          <div>
            <Label className="label-mono">New password</Label>
            <PasswordInput value={pw} onChange={(e) => setPw(e.target.value)} className="bg-input border-border mt-1" data-testid="force-new-password" onKeyDown={(e) => e.key === "Enter" && submit()} autoFocus />
          </div>
          <div>
            <Label className="label-mono">Confirm new password</Label>
            <PasswordInput value={confirm} onChange={(e) => setConfirm(e.target.value)} className="bg-input border-border mt-1" data-testid="force-confirm-password" onKeyDown={(e) => e.key === "Enter" && submit()} />
          </div>
          <Button onClick={submit} disabled={saving} className="w-full bg-primary text-primary-foreground hover:bg-primary/90" data-testid="force-save-password">
            {saving ? "Saving…" : "Set password & continue"}
          </Button>
          <button onClick={logout} className="w-full text-xs text-muted-foreground hover:text-foreground transition-colors" data-testid="force-logout">Sign out instead</button>
        </div>
      </div>
    </div>
  );
}
